const initialCourse = {
  id: null,
  name: "",
  displayOrder: null,
};

export default initialCourse;
